import ROSLIB from "roslib";

let ros = new ROSLIB.Ros({ url: process.env.VUE_APP_ROS_SERVER_URL });

export default {
  login(user) {
    let loginClient = new ROSLIB.Service({
      ros: ros,
      name: "/automato/login",
      serviceType: "services/Login",
    });

    let request = new ROSLIB.ServiceRequest({
      auth_data: user.username + ":" + user.password,
    });
    let promise = new Promise((resolve, reject) => {
      console.log("Sending login");
      loginClient.callService(request, function(result) {
        console.log("login return");
        return resolve(result.success);
      });
    });
    return promise;
  },
  emergency(stopped) {
    let emergencyTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/emergency",
      messageType: "std_msgs/String",
    });
    let onoff = stopped ? "ON" : "OFF";
    let stop = new ROSLIB.Message({ data: onoff });
    console.log("Sending emergency command: " + onoff);
    emergencyTopic.publish(stop);
  },
  updateSettings(settings) {
    let ros = new ROSLIB.Ros({ url: process.env.VUE_APP_ROS_SERVER_URL });
    let settingsTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/gui/settings",
      messageType: "std_msgs/String",
    });
    var settingsJSON = JSON.stringify(settings);
    var msg = new ROSLIB.Message({
      data: settingsJSON,
    });
    console.log("updating settings: " + settingsJSON);
    settingsTopic.publish(msg);
  },
  updateFarms(farms) {
    let farmsTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/gui/config",
      messageType: "std_msgs/String",
    });
    var farmsJSON = JSON.stringify(farms);
    var msg = new ROSLIB.Message({
      data: farmsJSON,
    });
    console.log("updating farms: " + farmsJSON);
    farmsTopic.publish(msg);
  },
  sendMappingCommand(cmd, farmId) {
    if (!["Enter", "Start", "Stop", "Kill", "Restart"].includes(cmd)) {
      throw "InvalidParameter";
    }
    let mappingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/mapping_command",
      messageType: "std_msgs/String",
    });
    let payloadj = { command: cmd, sim: "true", bag: "", farmId: farmId };
    let msg = new ROSLIB.Message({ data: JSON.stringify(payloadj) });
    mappingTopic.publish(msg);
    console.log("Sending mapping command: " + JSON.stringify(payloadj));
  },
  sendHarvestCommand(cmd, x, y) {
    if (!["Start", "Kill", "Unload", "Goto"].includes(cmd)) {
      throw "InvalidParameter";
    }
    let harvestTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/harvester/command",
      messageType: "std_msgs/String",
    });
    let payloadj = { command: cmd, x: x, y: y };
    let msg = new ROSLIB.Message({ data: JSON.stringify(payloadj) });
    console.log("Sending harvest command: " + JSON.stringify(payloadj));
    harvestTopic.publish(msg);
  },
  sendRoverSprayingCommand(cmd) {
    let sprayingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/payload/command_to_rover",
      messageType: "std_msgs/String",
    });
    let msg = new ROSLIB.Message({ data: cmd });
    console.log("Sending spraying command: " + cmd);
    sprayingTopic.publish(msg);
  },
  startStopSprayingValve(bool) {
    let sprayingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/sprayer_node/activate_sprayer",
      messageType: "std_msgs/Bool",
    });
    let msg = new ROSLIB.Message({ data: bool });
    console.log("Stop or start spraying valve: " + bool);
    sprayingTopic.publish(msg);
  },
  startOrStopSprayingMotor(bool) {
    let sprayingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/sprayer_node/motor_control",
      messageType: "std_msgs/Bool",
    });
    let msg = new ROSLIB.Message({ data: bool });
    console.log("Start or stop spraying motor: " + bool);
    sprayingTopic.publish(msg);
  },
  setSprayingRate(int) {
    let sprayingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/sprayer_node/rate",
      messageType: "std_msgs/Int16",
    });
    let msg = new ROSLIB.Message({ data: parseInt(int) });
    console.log("Sending spraying rate setting command: " + parseInt(int));
    sprayingTopic.publish(msg);
  },
  setPathShouldBeSprayed(bool) {
    let sprayingTopic = new ROSLIB.Topic({
      ros: ros,
      name: "/automato/sprayer_node/should_spray_centralpath",
      messageType: "std_msgs/Bool",
    });
    let msg = new ROSLIB.Message({ data: bool });
    console.log("Set path should be sprayed: " + bool);
    sprayingTopic.publish(msg);
  },
};
